import { useState } from "react";
import { useNavigate } from "react-router-dom";

const API = "/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true); setError("");
    try {
      const form = new FormData();
      form.append("username", email);
      form.append("password", password);
      const r = await fetch(`${API}/auth/login`, { method: "POST", body: form });
      const data = await r.json();
      if (!r.ok) throw new Error(data.detail || "Error");
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("nombre", data.nombre);
      navigate("/");
    } catch (e: any) { setError(e.message); }
    setLoading(false);
  };

  return (
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0D47A1,#1565C0)",display:"flex",alignItems:"center",justifyContent:"center",padding:"24px",fontFamily:"Nunito,sans-serif"}}>
      <div style={{background:"#fff",borderRadius:"24px",padding:"48px 40px",width:"100%",maxWidth:"400px",boxShadow:"0 20px 60px rgba(0,0,0,0.2)"}}>
        <div style={{textAlign:"center",marginBottom:"32px"}}>
          <div style={{fontFamily:"Montserrat,sans-serif",fontWeight:900,fontSize:"24px",color:"#0D47A1",marginBottom:"8px"}}>
            IMPORTACIONES <span style={{color:"#1976D2"}}>B&Y</span>
          </div>
          <div style={{color:"#6b7280",fontSize:"14px"}}>Panel Administrativo</div>
        </div>
        {error && <div style={{background:"#fef2f2",border:"1px solid #fecaca",color:"#ef4444",padding:"12px 16px",borderRadius:"12px",fontSize:"14px",marginBottom:"16px"}}>{error}</div>}
        <div style={{marginBottom:"16px"}}>
          <label style={{fontSize:"12px",fontWeight:700,color:"#6b7280",textTransform:"uppercase",letterSpacing:"1px",display:"block",marginBottom:"6px"}}>Email</label>
          <input value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="admin@importacionesby.com"
            style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"12px",padding:"12px 16px",fontSize:"14px",outline:"none",fontFamily:"Nunito,sans-serif"}}/>
        </div>
        <div style={{marginBottom:"24px"}}>
          <label style={{fontSize:"12px",fontWeight:700,color:"#6b7280",textTransform:"uppercase",letterSpacing:"1px",display:"block",marginBottom:"6px"}}>Contraseña</label>
          <input value={password} onChange={e=>setPassword(e.target.value)} type="password" placeholder="••••••••"
            style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"12px",padding:"12px 16px",fontSize:"14px",outline:"none",fontFamily:"Nunito,sans-serif"}}
            onKeyDown={e=>e.key==="Enter"&&handleLogin()}/>
        </div>
        <button onClick={handleLogin} disabled={loading}
          style={{width:"100%",background:"#0D47A1",color:"#fff",border:"none",padding:"14px",borderRadius:"12px",fontWeight:800,fontSize:"16px",cursor:"pointer",fontFamily:"Nunito,sans-serif",opacity:loading?0.7:1}}>
          {loading?"Ingresando...":"Ingresar"}
        </button>
      </div>
    </div>
  );
}
